import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pantry-used-up-check-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryUsedUpCheckItem = _resolveComponent("PantryUsedUpCheckItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getList(), (item) => {
      return (_openBlock(), _createBlock(_component_PantryUsedUpCheckItem, {
        key: item.id,
        data: item,
        onSelectTag: _ctx.onSelectTag
      }, null, 8, ["data", "onSelectTag"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}